module.exports = __webpack_public_path__ + "img/PL08142.9bc79f19.png";